type MarketingStatesType = {
  pageIsMarketing: boolean;
  pageIsHome: boolean;
  logged: boolean;
};

type MarketingArgumentTypes = {
  pageName: string | '';
  logged: boolean;
};

const marketingPages = [
  'Home',
  'Pricing',
  'CustomerStories',
  'CustomerArticle',
  'CGV',
  'CGU',
  'cookies',
  'PersonalData',
  'About',
  'Careers',
  'Contact',
  'SendDecision',
  'LawyerDirectory',
  'OfficeDirectory',
];

const putToLower = (element: string) => (element ? element.toLowerCase() : '');
const mapPagesToLower = (pages: Array<string>) => pages.map(putToLower);
const loweredMarketingPages = mapPagesToLower(marketingPages);
const matchMarketingPages = (currentPage: string) =>
  loweredMarketingPages.includes(putToLower(currentPage));

const isPageHome = (pageName: string | ''): boolean =>
  pageName ? putToLower(pageName) === 'home' : false;

function isItMarketing(currentPage: string) {
  return matchMarketingPages(currentPage);
}

export const isPageMarketing = (currentPage: string | ''): boolean =>
  !currentPage ? false : isItMarketing(currentPage);

export function shouldHideSearch({
  pageIsMarketing,
  pageIsHome,
  logged,
}: MarketingStatesType): boolean {
  if (pageIsMarketing) return pageIsHome ? !logged : true;
  return false;
}

export function isMarketingLogged({
  pageIsMarketing,
  pageIsHome,
  logged,
}: MarketingStatesType): boolean {
  return pageIsMarketing && !pageIsHome && logged;
}

export function marketingStates({ pageName, logged }: MarketingArgumentTypes) {
  const states = {
    pageIsHome: isPageHome(pageName),
    pageIsMarketing: isPageMarketing(pageName),
    logged,
  };
  const hideSearch = shouldHideSearch(states);
  const marketingLogged = isMarketingLogged(states);
  return { hideSearch, marketingLogged, userHasStartedToSearch: false };
}
